<template>
    <div>
        <Dj />
        <v-row class="justify-center">
            <v-col cols="10" md="6">
                <v-btn @click="change" block color="black" dark>
                    cambiar palabras
                </v-btn>
            </v-col>
            <v-col cols="10" md="6">
                <v-btn block color="black" dark to="/">
                    home
                </v-btn>
            </v-col>
        </v-row>
        <v-row class="justify-center" style="margin-top:10px;">
            <v-col cols="10" md="6">
                <v-sheet
                class=" text-center "
                color="blue-grey darken-3"
                dark
                style="padding:20px;"
                >
                    <div v-for="item in init_words" :key="item">
                        <h1>{{ item }}</h1>
                    </div>
                </v-sheet>
            </v-col>
        </v-row>
        <v-row class="justify-center text-center" style="display:none;">
            <v-col cols="10" md="6">
                <audio id="playlist" ref="playlist" controls autoplay>
                    <source :src="'../audios/'+init_song" type="audio/ogg">
                    Your browser does not support the audio element.
                </audio> 
            </v-col>
        </v-row>
    </div>
</template>

<script>
import Dj from './Dj.vue'
import data_ from '../plugins/data.json'

export default {
    name: 'Practice',
    mounted: function(){

        console.log(data_)
    },
    created: function () {
        this.song()
        this.change()
    },
    components: {
        Dj
    },
    data: () => ({
        init_song:'',
        end_song: false,
        songs_list:data_['songs'],
        init_words:[],
        words_list:data_['words']
    }),
    methods: {
        song: function(){
            const random = Math.floor(Math.random() * this.songs_list.length);
            this.init_song = this.songs_list[random]
        },
        change: function(){
            this.init_words = []

            while(this.init_words.length < 4){
                const random = Math.floor(Math.random() * this.words_list.length);

                // verificar que la palabra no este repetida
                if(!this.init_words.includes(this.words_list[random])){
                    this.init_words.push(this.words_list[random])
                }
            }
        }
    },
}
</script>
